import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
  containerBtns: {
    flex: 1,
    marginTop: 25,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  
  card: {
    marginTop: 8,
    width: 64,
    height: 64,
    borderWidth: 0.5,
    borderRadius: 4,
    borderColor: "#077A97",
    backgroundColor: "#FFF",
    alignItems: "center",
    justifyContent: "center",
    elevation: 4,
    ...Platform.select({
      android: {
        maxWidth: "80%",
      },
      ios: {
        maxWidth: 350,
      },
      default: {
        minWidth: 200,
        maxHeight: 36,
      },
    }),
  },

  textCard: {
    fontFamily: "Poppins_400Regular",
    color: "#077A97",
    fontSize: 16,
    textTransform: "uppercase",
    margin: 6,
  },
  contentCard: {
    marginRight: 10,
  },
});

export default styles;
